const enableProxy = process.env.NODE_ENV === 'debug';
let env = window.config;
if (enableProxy) {
    env = Object.assign({}, env, {
        enableProxy,
        client_id: process.env.VUE_APP_OAUTH_CLINET_ID,
        secret: process.env.VUE_APP_OAUTH_SECRET,
        redirectHost: process.env.VUE_APP_OAUTH_REDIRECT,
        oauthHost: process.env.VUE_APP_OAUTH_HOST,
        apiHost: process.env.VUE_APP_API,
        scope: process.env.VUE_APP_OAUTH_SCOPE,
        portalHost: process.env.VUE_APP_PORTAL_HOST
    });
    window.config = env;
}
export default env;
